


















































































































































import Vue, { PropType } from 'vue';
import Header from './Header.vue';
import MStoreItemsPerPage from './MStoreItemsPerPage.vue';
import MStoreExportToCsv from '@/components/shared/MStoreExportToCsv.vue';
import Toast from '@/classes/SnotifyConfiguration';
import { BTableHelpers } from '@/mixins/bTable';
import { ObjectUtils } from '@/utils/objectUtils';
import { BvTableFieldArray } from 'bootstrap-vue';
import { Dictionary } from '@/types';
import ResizeObserver from 'resize-observer-polyfill';

export default Vue.extend({
  name: 'MStoreTable',
  mixins: [BTableHelpers],
  props: {
    small: {
      type: Boolean,
      default: false
    },
    headerText: {
      type: String,
      required: true
    },
    errorMessage: {
      type: String,
      required: false
    },
    hasError: {
      type: Boolean,
      required: false
    },
    showHideFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    emptyText: {
      type: String,
      required: false
    },
    canHoverOnTableRow: {
      type: Boolean,
      required: false,
      default: true
    },
    rowClass: {
      type: Function,
      required: false
    },
    theadClass: {
      type: String,
      required: false,
      default: 'text-no-wrap'
    },
    tableId: {
      type: String,
      required: false
    },
    emitFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    showFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    currentPage: {
      type: Number,
      required: false,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      default: 20
    },
    searchQuery: {
      type: [String, Array],
      required: false,
      default: ''
    },
    sortBy: {
      type: String,
      required: false,
      default: ''
    },
    sortDesc: {
      type: Boolean,
      required: false,
      default: false
    },
    emptyHtml: {
      type: String,
      required: false,
      default: ''
    },
    pkField: {
      type: String,
      required: false
    },
    selectedPk: {
      required: false
    },
    pagination: {
      type: Boolean,
      required: false,
      default: true
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: true
    },
    stickyHeader: {
      type: [Boolean, String],
      required: false,
      default: false
    },
    allowWallboardMode: {
      type: Boolean,
      default: false
    },
    wallboardRefreshIntervalInSeconds: {
      type: Number,
      default: 0
    },
    filteringEnabled: {
      type: Boolean,
      default: true
    },
    filterFunction: {
      type: Function
    },
    exportToCsvVisible: {
      type: Boolean,
      required: false,
      default: false
    },
    showItemsPerPage: {
      type: Boolean,
      default: true
    },
    debounce: {
      type: Number
    },
    refreshButtonVisible: {
      type: Boolean,
      default: true
    },
    pinFilter: Boolean,
    enableCustomSorting: {
      type: Boolean,
      default: false
    },
    sortOptions: {
      type: Array,
      required: false
    },
    customFilteredSorted: {
      type: Boolean,
      default: false
    },
    pinSort: {
      type: Boolean,
      default: false
    },
    filteringSortingExcludedColumns: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    showSorting: {
      type: Boolean,
      default: false
    },
    selectedItemKeys: {
      default: () => [],
      type: Array
    },
    selectable: {
      default: false,
      type: Boolean
    },
    selectedRowClass: {
      type: String,
      default: 'table-primary'
    },
    selectedRowClassOverridesRowClass: {
      type: Boolean,
      default: false
    },
    totalItems: {
      type: Number,
      default: -1
    },
    resizable: {
      type: Boolean,
      default: false
    },
    canPinSortingAndFiltering: {
      type: Boolean,
      default: true
    },
    appliedSorting: {
      type: Array,
      required: false,
      default: () => [] 
    }
  },
  data(this: any) {
    return {
      internalCurrentPage: 1,
      internalItemsPerPage: 20,
      exportingToCsvStatus: false,
      filteredItems: [],
      paginatedItems: [],
      columnWidths: {} as Dictionary<number>,
      mouseDrag: false,
      lastSelectedItemIndex: -1
    };
  },
  methods: {
    onSorted(this: any, item: any) {
      this.$emit('on-filtered-or-sorted', this.$refs.mtable?.sortedItems);
    },
    onFiltered(this: any, filteredItems: any) {
      this.filteredItems = filteredItems;
      this.$emit('update:filtered-items', 'filteredItems', filteredItems);
      this.$emit('on-filtered-or-sorted', this.$refs.mtable?.sortedItems);
    },
    onRefresh() {
      this.$emit('refresh-clicked');
    },
    onExportToCSV(this: any) {
      this.exportingToCsvStatus = true;
    },
    exportCancelled(this: any) {
      this.exportingToCsvStatus = false;
    },
    exportFailed(error: any) {
      Toast.showError(error);
    },
    exportSucceeded(this: any) {
      this.exportingToCsvStatus = false;
      Toast.showSuccess('Table data exported successfully');
    },
    onMouseDown(event: MouseEvent) {
      // Prevents the default event on mouse down on the bootstrap table which causes issues with shift click (i.e. instead of the row being selected, row text gets selected without this)
      if (event.shiftKey) {
        event.preventDefault();
      }
    },
    rowClicked(this: any, item: any, index: any, event: any) {
      if (this.selectable) {
        if (event.ctrlKey === true) {
          this.$emit('row-clicked', item);
          this.$emit('update:selected-pk', 'selectedPk', item[this.primaryKey]);
          this.lastSelectedItemIndex = index;
          this.selectRow(item);
        } else if (event.shiftKey === true) {
          if (this.lastSelectedItemIndex < 0) {
            this.lastSelectedItemIndex = index;
            this.selectRow(item);
          } else {
            let itemsToSelect =
              index < this.lastSelectedItemIndex ? this.paginatedItems.slice(index, this.lastSelectedItemIndex + 1) : this.paginatedItems.slice(this.lastSelectedItemIndex, index + 1);
            const itemsToSelectKeys = itemsToSelect.map((x: any) => x[this.primaryKey].toString());
            itemsToSelect = itemsToSelect.filter((x: any) => !this.isRowSelected(x));
            this.$emit(
              'rows-selected',
              itemsToSelect.map((x: any) => x[this.primaryKey].toString())
            );
            const itemsToDeselect = this.selectedItemKeys.filter((x: any) => !itemsToSelectKeys.includes(x));
            if (itemsToDeselect.length > 0) {
              this.$emit('rows-selected', itemsToDeselect);
            }
          }
        }
      }
      this.$emit('row-clicked', item);
      this.$emit('update:selected-pk', 'selectedPk', item[this.primaryKey]);
    },
    doubleClicked(item: any) {
      this.$emit('double-clicked', item);
    },
    sortByChanged(item: any) {
      this.$emit('update:sort-by', 'sortBy', item);
    },
    sortDescChanged(item: any) {
      this.$emit('update:sort-desc', 'sortDesc', item);
    },
    setCurrentPage(this: any) {
      this.localCurrentPage = this.getCurrentPage();
    },
    selectRowByIndex(this: any, index: number) {
      this.$refs.mtable.selectRow(index);
    },
    initialise(this: any) {
      this.filteredItems = this.getFilteredItems();
      this.getPaginatedItems();
      this.setCurrentPage();
      this.$emit('on-filtered-or-sorted', this.filteredItems);
      this.$emit('on-items-changed', this.items);
    },
    getCurrentPage(this: any) {
      const itemsPerPage = this.itemsPerPage ? this.itemsPerPage : this.internalItemsPerPage;
      const index = this.filteredItems.findIndex((row: any) => row[this.primaryKey] === this.selectedPk);
      if (index > -1) {
        return Math.ceil((index + 1) / itemsPerPage);
      } else {
        return Math.min(this.currentPage, Math.ceil(this.totalRows / itemsPerPage));
      }
    },
    getFilteredItems(this: any) {
      if (this.sortBy) {
        return this.$refs.mtable?.sortedItems;
      }
      return this.$refs.mtable?.filteredItems || this.items;
    },
    checkItemsHasThePrimaryKey(this: any) {
      if (ObjectUtils.isNullOrEmpty(this.items[0])) {
        return false;
      }

      return Object.keys(this.items[0])?.some((field: any) => field === this.pkField);
    },
    selectRow(this: any, selectedRowItem: any) {
      const itemKey = selectedRowItem[this.primaryKey].toString() as string;
      this.$emit('row-selected', itemKey);
    },
    selectAllRows(this: any) {
      const selectedKeys = this.paginatedItems.map((x: any) => x[this.primaryKey].toString());
      this.$emit('rows-selected', selectedKeys);
    },
    isRowSelected(this: any, item: any) {
      return (this.selectedItemKeys as string[]).includes(item[this.primaryKey].toString());
    },
    getRowClass(this: any, item: any) {
      if (!this.items?.length) {
        return;
      }
      const rowClass = this.rowClass && this.rowClass(item);
      let selectedRowClass = '';
      if (this.selectable && this.selectedItemKeys.includes(item[this.primaryKey].toString())) {
        selectedRowClass = this.selectedRowClass;
      }
      const defaultRowClassPriority = [rowClass, selectedRowClass];
      const rowClassPriority = this.selectedRowClassOverridesRowClass ? defaultRowClassPriority.reverse() : defaultRowClassPriority;

      return rowClassPriority.find((x) => Boolean(x));
    },
    getPaginatedItems(this: any) {
      this.paginatedItems = this.$refs.mtable?.paginatedItems;
    },
    manageHeadClick(event: Event) {
      if (this.mouseDrag) {
        event.stopPropagation();
      }
    },
    onColumnHeaderClick(this: any, column: string, event: MouseEvent) {
      if (this.filteringSortingExcludedColumns.includes(column) || !this.enableCustomSorting) {
        return;
      }

      const field = this.fields.find((f: any) => f.key === column);
      if (!field) {
        return;
      }

      const existingSortIndex = this.sortOptions.findIndex((option: any) => option.sortingKey === column);
      const isMultiSort = event.ctrlKey || event.metaKey;

      if (isMultiSort) {
        this.handleMultiSort(column, existingSortIndex);
      } else {
        this.handleSingleSort(column, existingSortIndex);
      }

      this.$emit('update:apply-sort');
    },

    handleMultiSort(this: any, column: string, existingSortIndex: number) {
      if (existingSortIndex >= 0) {
        this.toggleExistingSortOption(column, existingSortIndex);
      } else {
        this.addNewSortOption(column);
      }
    },

    handleSingleSort(this: any, column: string, existingSortIndex: number) {
      const shouldUpdateExisting = this.sortOptions.length === 1 && existingSortIndex === 0;
      
      if (shouldUpdateExisting) {
        this.toggleExistingSortOption(column, existingSortIndex);
      } else {
        this.resetAndAddSort(column);
      }
    },

    toggleExistingSortOption(this: any, column: string, existingSortIndex: number) {
      const existingOption = this.sortOptions[existingSortIndex];
      const updatedOption = {
        sortingKey: column,
        isSortingAscending: !existingOption.isSortingAscending
      };
      this.$emit('update:update-sort-option', existingSortIndex, updatedOption);
    },

    addNewSortOption(this: any, column: string) {
      const newSortOption = {
        sortingKey: column,
        isSortingAscending: true
      };
      this.$emit('update:add-sort-option', newSortOption);
    },

    resetAndAddSort(this: any, column: string) {
      this.$emit('update:reset-sorting');
      this.addNewSortOption(column);
    },
    mouseDown(this: any) {
      this.mouseDrag = false;
    },
    mouseMove(this: any) {
      this.mouseDrag = true;
    },
    getSortOrderForColumn(this: any, column: string) {
      if (!this.enableCustomSorting || !this.appliedSorting) {
        return null;
      }

      const sortIndex = this.appliedSorting.findIndex((option: any) => option.sortingKey === column);
      return sortIndex >= 0 ? sortIndex + 1 : null;
    },
    getSortDirectionIcon(this: any, column: string) {
      if (!this.appliedSorting) {
        return null;
      }

      const sortOption = this.appliedSorting.find((option: any) => option.sortingKey === column);
      if (!sortOption) {
        return null;
      }

      return sortOption.isSortingAscending ? ['fas', 'fa-arrow-up-short-wide'] : ['fas', 'fa-arrow-down-short-wide'];
    },
    showSortOrder(this: any, column: string) {
      if (!this.enableCustomSorting || !this.sortOptions) {
        return false;
      }
      const isColumnSorted = this.appliedSorting.some((option: any) => option.sortingKey === column);
      const hasMultipleSorts = this.appliedSorting.length > 1;
      return isColumnSorted && hasMultipleSorts;
    }
  },
  watch: {
    isLoading(this: any) {
      if (!this.isLoading) {
        this.$nextTick(() => {
          this.initialise();
        });
      }
    }
  },
  computed: {
    localCurrentPage: {
      get(this: any): number {
        return this.emitFilters ? this.currentPage : this.internalCurrentPage;
      },
      set(this: any, value: any) {
        if (this.emitFilters) {
          this.$emit('update:current-page', 'currentPage', Math.max(1, value));
        } else {
          this.internalCurrentPage = Math.max(1, value);
        }
      }
    },
    localItemsPerPage: {
      get(this: any): number {
        return this.emitFilters || !this.showItemsPerPage ? this.itemsPerPage : this.internalItemsPerPage;
      },
      set(this: any, value: any) {
        if (this.emitFilters) {
          this.$emit('update:items-per-page', 'itemsPerPage', value);
        } else {
          this.internalItemsPerPage = value;
        }
      }
    },
    primaryKey(this: any) {
      return this.pkField && (this.fields.some((field: any) => field.key === this.pkField) || this.checkItemsHasThePrimaryKey()) ? this.pkField : this.getKey(this.fields[0]);
    },
    bTableFields(this: any) {
      this.fields.forEach((field: any) => {
        if (this.items?.length > 0) {
          const fieldValue = this.items.map((item: any) => item[field.key]).find((value: any) => value);
          if (fieldValue?.toString().isUkShortDateFormat()) {
            field.formatter = 'date';
          }
        }
      });
      const columnsToPrepend = [] as BvTableFieldArray;
      if (this.selectable) {
        columnsToPrepend.push({ key: 'selected', label: '', thStyle: { width: 0 }, tdClass: 'align-middle no-resize', thClass: 'align-middle no-resize' });
      }
      return [...columnsToPrepend, ...this.fields];
    },
    exportToCsvEnabled(this: any) {
      return Boolean(this.itemsToExport?.length);
    },
    totalRows(this: any) {
      return this.customFilteredSorted ? this.items.length : this.filteredItems.length || this.searchQuery ? this.filteredItems.length : this.items.length;
    },
    itemsToExport() {
      return this.customFilteredSorted ? this.items : this.filteredItems;
    },
    allRowsSelected(this: any) {
      const items = [...this.items];
      return items.length ? (this.paginatedItems as any[])?.map((x) => x[this.primaryKey].toString()).every((key) => this.selectedItemKeys.includes(key)) : [];
    },
    headerTextComputed(this: any) {
      return this.totalItems < 0 ? `${this.headerText} - ${this.totalRows} Items` : `${this.headerText} - Showing ${this.totalRows} of ${this.totalItems} Items`;
    },
    columnKeys() {
      return (this.fields as Array<{ key: string }>).map((x) => x.key);
    },
    columnWidthStyles() {
      return this.resizable
        ? (this.columnKeys as string[]).reduce(
            (styles, columnKey) => ({
              ...styles,
              [columnKey]: { width: this.columnWidths[columnKey] ? `${this.columnWidths[columnKey]}px` : 'auto' }
            }),
            {}
          )
        : {};
    },
    tableStyle() {
      return Object.values(this.columnWidths).some((x) => x) ? undefined : { 'min-width': '100%' };
    }
  },
  mounted(this: any) {
    this.initialise();
    this.$watch(
      () => (this.$refs.mtable as any).paginatedItems,
      (updatedItems: any[]) => {
        this.paginatedItems = updatedItems;
        this.lastSelectedItemIndex = -1;
        this.$emit('update:paginated-items', updatedItems?.map((x: any) => x[this.primaryKey]?.toString()) ?? []);
      }
    );
    const columns = this.fields.map((x: any) => x.key);
    if (this.resizable) {
      columns.forEach((fieldKey: string) => {
        new ResizeObserver((resizeEntries: ResizeObserverEntry[]) => {
          const newWidth = (resizeEntries as any[]).find((x) => x.borderBoxSize)?.borderBoxSize.find((x: any) => x.inlineSize)?.inlineSize;
          Vue.set(this.columnWidths, fieldKey, Math.round(newWidth) ?? 0);
        }).observe(this.$refs[`table-head-div-${fieldKey}`] as Element);

        (this.$refs[`table-head-div-${fieldKey}`] as Element).addEventListener('mousedown', this.mouseDown);
        (this.$refs[`table-head-div-${fieldKey}`] as Element).addEventListener('mousemove', this.mouseMove);
      });
    }
  },
  beforeDestroy(this: any) {
    if (this.resizable) {
      this.fields
        .map((x: any) => x.key)
        .forEach((key: string) => {
          (this.$refs[`table-head-div-${key}`] as Element).removeEventListener('mousedown', this.mouseDown);
          (this.$refs[`table-head-div-${key}`] as Element).removeEventListener('mousemove', this.mouseMove);
        });
    }
  },
  components: {
    Header,
    MStoreExportToCsv,
    MStoreItemsPerPage
  }
});
